<template>
  <div class="page-container has-action">
    <!--<div class="demo">
            <img src="/img/demo/detail.png">
        </div>-->
    <van-nav-bar left-arrow fixed :title="detail.name" @click-left="" :z-index="10"></van-nav-bar>
    <div class="detail">
      <div class="box">
        <div v-if="countDown" class="count-down">
          <img src="/img/detail/count-down.png" />
          <span>倒计时</span>
          <van-count-down :time="countDown" @finish="finish" format="DD天 HH时 mm分 ss秒"></van-count-down>
        </div>
        <div class="flex-row mt-20 info">
          <div class="item rate">
            <div class="color-gray-dark name fs-16">预期年化折扣率</div>
            <div class="color-red fs-32">{{ detail.expectedRate }}%</div>
          </div>
          <div class="item duration">
            <div class="color-gray-dark name fs-16">投资期限</div>
            <div class="fs-32 color-dark">{{ detail.investDuration }}天</div>
          </div>
        </div>
        <div class="mt-20 info2">
          <div class="color-golden">{{ getRiskRating }}</div>
          <div class="color-gray-light">|</div>
          <div class="ta-c">{{ miniAmount }}万元起购</div>
          <div class="color-gray-light">|</div>
          <div>
            <div class="progress">
              <div class="progress-pivot" :style="{ width: detail.sold + '%' }"></div>
              <div class="text fs-12" :style="{
                  backgroundImage:
                    'linear-gradient(to right,#fff 0%, #fff ' +
                    detail.sold +
                    '% ,#DF4744 ' +
                    detail.sold +
                    '%,#DF4744 100%)'
                }">
                已售{{ detail.sold }}%
              </div>
            </div>
          </div>
          <div class="color-gray-light">|</div>
          <div class="ta-r" v-if="detail.sold < 100">
            还剩{{ (detail.raisedAmount - detail.currentRaise) / 1000000 }}万元
          </div>
          <div class="ta-r" v-else>已售罄</div>
        </div>
      </div>
      <div class="box feature">
        <div class="mb-10 fs-18 color-dark title">资产特点</div>
        <div class="blank" style="height: 4.3rem"></div>
        <template v-for="(n, i) of detail.keyMap">
          <div class="mt-10" v-if="n.type == 1" :key="i">
            <div class="">{{ n.key }}</div>
            <div class="mb-5 color-gray-dark fs-12 value" v-html="n.val"></div>
          </div>
          <div class="mt-10" v-if="n.type == 3" :key="i">
            <img :src="n.val" style="width: 80%" />
          </div>
          <div class="ta-c mt-10" v-if="n.type == 4" :key="i">
            <video :src="n.val"></video>
          </div>
        </template>
      </div>
      <div class="blank" style="height: 3.1rem"></div>
      <div class="box time-line">
        <div class="mb-10 fs-18 color-dark title">投资期限</div>
        <div class="content">
          <table>
            <tr class="text">
              <td style="width: 30%">
                {{ dateFormat(detail.beginDate, "MM.DD") }}
              </td>
              <td>
                <div class="ta-l">
                  <div>{{ dateFormat(detail.valueDate, "MM.DD") }}</div>
                </div>
              </td>
              <td>
                <div class="ta-r">
                  <div>{{ dateFormat(detail.dueDate, "YYYY.MM.DD") }}</div>
                </div>
              </td>
            </tr>
            <tr class="scale">
              <td>&nbsp;</td>
              <td class="ta-c" colspan="2">&nbsp;</td>
            </tr>
            <tr class="graph">
              <td></td>
              <td class="ta-c" colspan="2">资产持有期</td>
            </tr>
            <tr class="text">
              <td>
                <div>开放募集</div>
              </td>
              <td colspan="2">
                <div class="fl">
                  <div>收益起算日</div>
                  <div>前一日结束募集</div>
                </div>
                <div class="fl-r">收益到期日</div>
              </td>
            </tr>
          </table>
          <div class="mt-20 fs-12">
            投资者受让该资产成功后，从收益起算日至收益到期日，期间不可提前退出投资。收益到期日本金及收益一次性兑付给投资者。
          </div>
        </div>
      </div>
      <div class="blank" style="height: 0.4rem"></div>
      <div class="box rule">
        <div class="mb-10 fs-18 color-dark title">交易规则</div>
        <table>
          <template v-for="(n, i) of detail.keyMap">
            <tr v-if="n.type == 2" :key="'rule-' + i">
              <th>{{ n.key }}</th>
              <td>{{ n.val }}</td>
            </tr>
          </template>
        </table>
      </div>
      <div class="blank" style="height: 3.5rem"></div>
      <div class="box record">
        <div class="mb-10 fs-16 color-dark title">资产档案</div>
        <div>
          <van-cell v-for="(n, i) of detail.protocolList" :key="'protocol-' + i" :title="n.name" is-link />
        </div>
      </div>
      <div class="blank" style="height: 0.4rem"></div>
      <div class="box qa" style="">
        <div class="mb-20 fs-18 color-dark title">常见问题</div>
        <ul>
          <li class="item mt-15">
            <div class="flex-row q">
              <div class="tag">Q</div>
              <div class="text">
                “{{ detail.typeName }}” 资产转让系列投资人的收益方式是什么？
              </div>
            </div>
            <div class="flex-row mt-5 a">
              <div class="tag">A</div>
              <div class="text">
                到期一次性兑付，“{{
                  detail.typeName
                }}”资产转让系列在转让到期日由转让/回购方进行溢价回购，相关投资本金和收益在不晚于资产转让到期日后三个工作日内兑付投资人。
              </div>
            </div>
          </li>
          <li class="item mt-15">
            <div class="flex-row q">
              <div class="tag">Q</div>
              <div class="text">可以要求回购方提前回购吗？</div>
            </div>
            <div class="flex-row mt-5 a">
              <div class="tag">A</div>
              <div class="text">
                在投资人受让资产收益起算日起，至资产转让到期日止，投资人不得要求提前提取受让资金。
              </div>
            </div>
          </li>
          <li class="item mt-15">
            <div class="flex-row q">
              <div class="tag">Q</div>
              <div class="text">
                "{{
                  detail.typeName
                }}"资产转让系列在投资开放期内是否可以撤销投资？
              </div>
            </div>
            <div class="flex-row mt-5 a">
              <div class="tag">A</div>
              <div class="text">
                投资人在确认受让该资产后，资金被冻结，即进入“申请中”状态，资金冻结期间投资人是不能撤销投资，申请受让前请谨慎考虑！
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="pb-20" style="height: 50px"></div>
    </div>

    <div class="page-action">
      <van-button type="danger" size="large" class="buy" :disabled="!canbuy">{{
        canbuy_txt
      }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  Progress,
  NavBar,
  Row,
  Col,
  Icon,
  Cell,
  CellGroup,
  Collapse,
  CollapseItem,
  Button,
  Toast,
  Dialog,
  CountDown,
  Popup
} from "vant"
import * as ProductApi from "@/api/product"
import moment from "moment"
import storage from "@/utils/storage"
import { mapActions, mapGetters } from "vuex"
import store from "../../store"

export default {
  components: {
    [NavBar.name]: NavBar,
    [Progress.name]: Progress,
    [CountDown.name]: CountDown,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog
  },

  data: () => ({
    canbuy: true,
    canbuy_txt: "买入",

    productId: null,
    detail: {},
    assessShow: false,
    activeNames: [],
    loading: false
  }),

  methods: {
    // 倒计时结束时触发
    finish() {
      this.canbuy = false
      this.canbuy_txt = "资产募集已结束"
    },

    fetchData() {
      this.productId = this.$route.query.productId
      this._showLoading()
      const p1 = ProductApi.preview(this.productId)
        .then((data) => {
          this.detail = data
          this.productId = this.detail.id
          this.$nextTick(() => {
            this._onScrollyTo(0)
          })
          if (this.detail.sold == 100) {
            this.canbuy = false
            this.canbuy_txt = "资产已抢光"
          }
          this._dismissLoading()
        })
        .catch((e) => {
          this._dismissLoading()
          if (e) {
            Toast(e.msg || e.message)
          }
        })
    },

    formatPrice() {
      return "¥" + (this.detail.price / 100).toFixed(2)
    },

    goAssess() {
      this.$router.push({
        path: "/questions",
        query: { productId: this.productId }
      })
    }
  },
  computed: {
    countDown: function () {
      if (this.detail.endTime && !this.detail.isFull) {
        let time = moment(this.detail.endTime).diff(this.detail.serverTime)
        return time
      } else {
        return 0
      }
    },
    miniAmount: function () {
      if (
        this.detail.raisedAmount - this.detail.currentRaise <
        this.detail.miniAmount &&
        this.detail.sold < 100
      ) {
        return (this.detail.raisedAmount - this.detail.currentRaise) / 1000000
      } else {
        return this.detail.miniAmount / 100 / 10000
      }
    },

    progress: function () {
      if (this.detail.raisedAmount) {
        return parseInt(
          (this.detail.currentRaise / this.detail.raisedAmount) * 100
        )
      } else {
        return false
      }
    },
    getRiskRating: function () {
      /**
       * 5低风险
       * 4中低风险
       * 3中风险
       * 2中高风险
       * 1高风险
       */
      switch (this.detail.riskRating) {
        case 1:
          return "高风险"
          break
        case 2:
          return "中高风险"
          break
        case 3:
          return "中风险"
          break
        case 4:
          return "中低风险"
          break
        case 5:
          return "低风险"
          break
        default:
          return "低风险"
          break
      }
    }
  },

  beforeMount() {
    this.fetchData()
  }
}
</script>

<style lang="less" scoped>
.blank {
  display: none;
}

.demo {
  position: absolute;
  top: -20px;
  left: 0;
  width: 100%;
  z-index: 10000;
  opacity: 0.5;
  img {
    width: 100%;
  }
}
.page-container {
  background: #f1f5f8;
}
.detail {
  .box {
    padding: 20px;
    background: @white;
    margin-top: 5px;
  }
  .box:first-child {
    padding-top: 15px;
    margin-top: 0;
  }

  .count-down {
    font-size: 16px;
    text-align: center;
    img {
      margin-right: 10px;
      position: relative;
      height: 24px;
      color: @red;
      top: 5px;
    }
    .van-count-down {
      font-size: 16px;
      margin-left: 30px;
      color: #c7a673;
      display: inline-block;
    }
  }
  .info {
    justify-content: space-around;

    .item {
      box-sizing: border-box;
      &.rate {
        width: 50%;
      }
      &.duration {
        width: 50%;
      }
    }
  }
  .info2 {
    border-right: 0;
    border-left: 0;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    border-top: 1px solid;
    border-bottom: 1px solid;
    padding: 10px 0 8px 0;
    line-height: 32px;
    background: #fff;
    border-color: #c1a76a;
    border-image: linear-gradient(to left, #c1a76a, #f4e1b0, #c1a76a) 1;
  }

  .progress {
    margin-top: 5px;
    width: 70px;
    height: 20px;
    line-height: 20px;
    position: relative;
    border: 1px solid @red;
    .progress-pivot {
      height: 100%;
      background: linear-gradient(to left, #f68d85, @red);
    }
    .text {
      position: absolute;
      height: 100%;
      width: 100%;
      text-align: center;
      top: 0;
      left: 0;
      //background-image: linear-gradient(to right,#fff 0%, #fff 72% ,#DF4744 72%,#DF4744 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .feature {
    video {
      width: 100%;
      border-radius: 10px;
    }
    a {
      color: @dark;
    }
  }
  .time-line {
    table {
      border-collapse: separate;
      border-spacing: 5px 0;
      font-size: 12px;
      width: 100%;
      td {
        vertical-align: top;
      }
      tr.text td {
        padding: 2px;
      }
      tr.scale td {
        border-left: 1px solid @gray;
      }
      tr.scale td:last-child {
        border-left: 1px solid @golden;
        border-right: 1px solid @golden;
      }
      tr.graph td {
        padding: 3px;
      }
      tr.graph td:nth-child(1) {
        background: url("/img/detail/bg-1.png") repeat-x;
        background-size: auto 100%;
      }

      tr.graph td:last-child {
        border: 1px solid @golden;
        background: #f9f7f3;
      }
      tr.text {
      }
    }
  }
  .rule {
    th {
      width: 100px;
      text-align: left;
      font-weight: normal;
    }
    td {
      color: @gray-dark;
      padding-left: 20px;
    }
  }

  .record {
    ::v-deep .van-cell {
      padding: 10px 0;
      &:not(:last-child)::after {
        border: none;
      }
    }
    ::v-deep .van-collapse-item .van-collapse-item__content {
      padding-top: 0;
    }
    .van-hairline--top-bottom::after {
      border: none;
    }
  }
  .qa {
    .tag {
      font-size: 10px;
      width: 14px;
      height: 14px;
      line-height: 14px;
      text-align: center;
      margin-right: 10px;
      color: #fff;
      border: 1px solid @dark;
    }

    .text {
      font-size: 12px;
      flex: 1;
    }
    .q .tag {
      background-color: @dark;
    }
    .a .tag {
      color: @dark;
      background-color: @white;
    }
    .a .text {
      color: @gray-dark;
    }
  }
}

.assess-dialog {
  padding: 0.8rem;
  width: 70vw;

  .btn-assess {
    width: 70%;
    color: @golden;
    font-size: @font-size-xxl;
    border-color: @golden;
    border-radius: 5px;
  }
}
</style>
